<template>
<el-container>
  <div v-if="ismobile === false">
    <publicHeader :currencyShow="currencyShow" ref="child" :accountChange="accountChange" @hotelLanguage="hotelLanguage"></publicHeader>
  </div>
  <div v-else>
    <div style="height:60px; background-color:rgba(79, 76, 76, 1);">
      <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;" @click="goback()"></i>
      <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('myAccount')}}</div>
    </div>
  </div>
  <el-main>
      <div class="main" :class="{'mobile-main': ismobile}" :style="{ height: `${elementHeight}px`}">
          <publicAccountMenu></publicAccountMenu>
          <!-- 我的行程 -->
          <div class="account-show" v-if="ismobile === false">
              <div class="account-center">
                  <div class="account-data-info">
                      <div class="notice">
                          <!-- 提示信息样式 -->
                        <transition>
                          <div class="remind-notice my-message" v-show="remindNoticeShow">
                            <div class="remindinfo">
                              <img src="/static/img/login/notice.png">
                              <div class="remind-notice-text">{{$t(remindNotice)}}</div>
                            </div>
                          </div>
                        </transition>
                          <!-- 操作成功消息样式 -->
                        <transition>
                          <div class="remind my-message" v-show="remindSuccessShow">
                            <div class="remindinfo">
                              <div class="img-success">
                                <img src="https://res.roompai.com/static/img/account/my-payment-yes.png">
                              </div>
                              <div class="remind-text">{{$t(remindSuccess)}}</div>
                            </div>
                          </div>
                        </transition>
                          <!-- 操作失败消息样式 -->
                          <transition>
                          <div class="remind-faild my-message" v-show="remindFailShow">
                            <div class="remindinfo">
                              <div class="img-faild">
                                <img src="https://res.roompai.com/static/img/account/my-error.png">
                              </div>
                              <div class="remind-text-faild">{{$t(remindFail)}}</div>
                            </div>
                          </div>
                          </transition>
                      </div>
                      <div class="clearBoth account-roominfo-clear"></div>
                      <el-skeleton animated :loading="userLoading">
                        <template slot="template">
                          <div class="account-detail pc" id="userInfo">
                              <div class="account-detail-top">
                                  <div class="account-detail-data">
                                    <el-skeleton-item variant="text" style="float: left; width: 200px; height: 20px; margin-top: 15px;"/>
                                  </div>
                              </div>
                              <div class="detail-main">
                                <!--姓名显示-->
                                <div class="detail-main-line" v-show="!nameInput">
                                  <div class="title">
                                    <div class="name"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                  </div>
                                  <div class="value"><el-skeleton-item variant="text" style="width: 150px;"/></div>
                                  <el-button class="pc-button-right" type="text"><el-skeleton-item variant="text" style="width: 80px;"/></el-button>
                                </div>
                                <!--邮箱显示-->
                                <div class="detail-main-line">
                                    <div class="title">
                                      <div class="name"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                    </div>
                                    <div class="value">
                                      <el-skeleton-item variant="text" style="width: 150px;"/>
                                    </div>
                                </div>
                                <!--手机号显示-->
                                <div class="detail-main-line">
                                  <div class="title">
                                    <div class="name"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                  </div>
                                  <div class="value"><el-skeleton-item variant="text" style="width: 150px;"/></div>
                                  <el-button class="pc-button-right" type="text"><el-skeleton-item variant="text" style="width: 80px;"/></el-button>
                                </div>
                                <!--微信显示-->
                                <div class="detail-main-line">
                                    <div class="title">
                                      <div class="name"><el-skeleton-item variant="text" style="width: 100px;"/></div>
                                    </div>
                                    <div class="value"><el-skeleton-item variant="text" style="width: 150px;"/></div>
                                    <el-button class="pc-button-right" type="text"><el-skeleton-item variant="text" style="width: 80px;"/></el-button>
                                </div>
                              </div>
                          </div>
                        </template>
                        <template>
                          <div class="account-detail pc" id="userInfo">
                              <div class="account-detail-top">
                                  <div class="account-detail-data">
                                    <div class="mobile-title">{{$t('userDetails')}}（{{$t('userId')}}：{{ userId }}）</div>
                                  </div>
                              </div>
                              <div class="detail-main">
                                <!--姓名显示-->
                                <div class="detail-main-line" v-show="!nameInput">
                                  <div class="title">
                                    <div class="name">{{$t('name')}}</div>
                                  </div>
                                  <div class="value">{{ lastname }} {{ firstname }}</div>
                                  <el-button class="pc-button-right" type="text" @click="nameInput=true; firstnameError=false; lastnameError=false; firstnameInput=firstname; lastnameInput=lastname">{{$t('edit')}}</el-button>
                                </div>
                                <!--姓名编辑-->
                                <div class="detail-main-line account-edit-main" v-show="nameInput">
                                  <div class="line">
                                      <div class="title">{{ $t('lastName') }}</div>
                                      <div class="clearBoth account-roominfo-clear-5"></div>
                                      <el-input v-model.trim="lastnameInput" :placeholder="$t('lastName')" ref="lastName" @blur="checkEnglish('lastName')"></el-input>
                                      <div class="errorNotice" v-show="lastnameError">{{$t('pleaseTextEnglish')}}</div>
                                  </div>
                                  <div class="line">
                                      <div class="title">{{ $t('firstName') }}</div>
                                      <div class="clearBoth account-roominfo-clear-5"></div>
                                      <el-input v-model.trim="firstnameInput" :placeholder="$t('firstName')" ref="firstName" @blur="checkEnglish('firstName')"></el-input>
                                      <div class="errorNotice" v-show="firstnameError">{{$t('pleaseTextEnglish')}}</div>
                                  </div>
                                  <div class="button">
                                    <el-button class="buttonCancel" @click="nameInput=false">{{ $t('buttonCancel') }}</el-button>
                                    <el-button class="buttonSave" @click="editAccount()">{{ $t('buttonSave') }}</el-button>
                                  </div>
                                </div>

                                <!--邮箱显示-->
                                <div class="detail-main-line" v-show="!emailBind">
                                    <div class="title">
                                      <div class="name">{{$t('email')}}</div>
                                      <div v-if="email === ''" class="icon_blue_solid">{{ $t('iconNotBound') }}</div>
                                      <div v-if="email !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
                                      <div v-if="email !=='' && isVerify !== '1'" class="icon_red_hollow">{{ $t('iconNotVerified') }}</div>
                                      <div v-if="email !== '' && isVerify === '1'" class="icon_green_hollow">{{ $t('iconVerified') }}</div>
                                    </div>
                                    <div class="value">
                                      {{email}}
                                      <el-button v-if="email !== '' && isVerify !== '1'" type="text" @click="checkEmail" class="padding0">{{$t('buttonCheckEmail')}}</el-button>
                                    </div>
                                  <el-button class="pc-button-right" v-if="email !== '' && isVerify !== '1'" type="text" @click="unbindEmail">{{$t('buttonUnBindEmail')}}</el-button>
                                  <el-button class="pc-button-right" v-if="email === ''" type="text" @click="emailBind=true;emailInput='';passwordInput='';retypePasswordInput=''">{{$t('buttonBindEmail')}}</el-button>
                                </div>
                                <!--邮箱绑定-->
                                <div class="detail-main-line account-edit-main" v-show="emailBind">
                                  <div class="line width80">
                                    <div class="title">{{ $t('email') }}</div>
                                    <div class="clearBoth account-roominfo-clear-5"></div>
                                    <el-input v-model.trim="emailInput" :placeholder="$t('email')"></el-input>
                                    <div class="errorNotice" v-show="emailError">{{$t(emailErrorMsg)}}</div>
                                  </div>
                                  <div class="line width80">
                                    <div class="title">{{ $t('password') }}</div>
                                    <div class="clearBoth account-roominfo-clear-5"></div>
                                    <el-input type="password" v-model.trim="passwordInput" :placeholder="$t('password')" show-password></el-input>
                                    <div class="errorNotice" v-show="passWordError">{{$t('passWordError')}}</div>
                                  </div>
                                  <div class="line width80">
                                    <div class="title">{{ $t('retypePassword') }}</div>
                                    <div class="clearBoth account-roominfo-clear-5"></div>
                                    <el-input type="password" v-model.trim="retypePasswordInput" :placeholder="$t('retypePassword')" show-password></el-input>
                                    <div class="errorNotice" v-show="passWordTwoError">{{$t('passWordTwoError')}}</div>
                                  </div>
                                  <div class="button">
                                    <el-button class="buttonCancel" @click="emailBind=false">{{ $t('buttonCancel') }}</el-button>
                                    <el-button class="buttonSave" @click="bindEmail()">{{ $t('buttonBindEmail') }}</el-button>
                                  </div>
                                </div>

                                <!--手机号显示-->
                                <div class="detail-main-line" v-show="!mobileBind">
                                  <div class="title">
                                    <div class="name">{{$t('mobile')}}</div>
                                    <div v-if="mobile === ''" class="icon_blue_solid">{{ $t('iconNotBound') }}</div>
                                    <div v-if="mobile !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
                                  </div>
                                  <div class="value">{{mobile}}</div>
                                  <el-button class="pc-button-right" v-if="mobile !== ''" type="text" @click="mobileBind=true;oldMobileInput='';mobileInput='';codeInput=''">{{$t('buttonUpdateMobile')}}</el-button>
                                  <el-button class="pc-button-right" v-if="mobile === ''" type="text" @click="mobileBind=true;oldMobileInput='';mobileInput='';codeInput=''">{{$t('buttonBindMobile')}}</el-button>
                                </div>
                                <!--手机号绑定-->
                                <div class="detail-main-line account-edit-main" v-show="mobileBind">
                                  <div class="line width85" v-show="mobile !== ''">
                                    <div class="title">{{ $t('oldmobile') }}</div>
                                    <div class="clearBoth account-roominfo-clear-5"></div>
                                    <el-select style="width:25%;" v-model="oldSelectTel" :placeholder="$t('pleaseSelect')">
                                      <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                                    </el-select>
                                    <el-input style="width:73%;" :placeholder="$t('oldmobile')" v-model="oldMobileInput"></el-input>
                                    <div class="errorNotice" v-show="oldMobileError">{{$t(oldMobileError)}}</div>
                                  </div>
                                  <div class="line width85">
                                    <div class="title">{{ $t('newmobile') }}</div>
                                    <div class="clearBoth account-roominfo-clear-5"></div>
                                    <el-select style="width:25%;" v-model="newSelectTel" :placeholder="$t('pleaseSelect')">
                                      <el-option v-for="item in telOptions" :label="item.telnum" :key="item.id" :value="item.id">{{item.value}}</el-option>
                                    </el-select>
                                    <el-input style="width:50%;" :placeholder="$t('newmobile')" v-model="mobileInput"></el-input>
                                    <el-button style="width: 23%;" class="send_mobile_code" @click="getMobileCode()">
                                      <span v-show="this.expireTime === 0">{{$t('getMobileCode')}}</span>
                                      <span v-show="this.expireTime > 0">{{expireTime}}S</span>
                                    </el-button>
                                    <div class="errorNotice" v-show="newMobileError">{{$t(newMobileError)}}</div>
                                  </div>
                                  <div class="line width85">
                                    <el-input style="width: 100%" v-model="codeInput" :placeholder="$t('inputMobileCode')"></el-input>
                                    <div class="errorNotice" v-show="mobileCodeError">{{$t(mobileCodeError)}}</div>
                                  </div>
                                  <div class="button">
                                    <el-button class="buttonCancel" @click="mobileBind=false">{{ $t('buttonCancel') }}</el-button>
                                    <el-button class="buttonSave" @click="bindMobile()">{{ $t('buttonBindMobile') }}</el-button>
                                  </div>
                                </div>
                                <!--微信显示-->
                                <div class="detail-main-line">
                                    <div class="title">
                                      <div class="name">{{$t('wechat')}}</div>
                                      <div v-if="wechatAccount === ''" class="icon_blue_solid">{{ $t('iconNotBound') }}</div>
                                      <div v-if="wechatAccount !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
                                    </div>
                                    <div class="value">{{wechatAccount}}</div>
                                    <el-button class="pc-button-right" v-if="wechatAccount !== '' && email !== '' && isVerify === '1'" type="text" @click="UnBindWechat">{{$t('unBindWechat')}}</el-button>
                                    <el-button class="pc-button-right" v-if="wechatAccount === ''" type="text" @click="pcBindWechatShowQRCode">{{$t('bindWechat')}}</el-button>
                                    <wxlogin id="wx" v-show="false" appid="wx4a536782ca2e3f8c" state="wx4a536782ca2e3f8c" scope="snsapi_login" theme="black"  :redirect_uri="this.common.getWechatTransferPage('wx4a536782ca2e3f8c')" href="data:text/css;base64,QGNoYXJzZXQgIlVURi04IjsKLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5Om5vbmV9" height="355px" :lang="this.$i18n.locale"></wxlogin>
                                </div>
                              </div>
                            <!--帐号管理-->
                            <div class="account-detail-top">
                              <div class="account-detail-data">
                                <div class="mobile-title">{{ $t('accountManagement') }}</div>
                              </div>
                            </div>
                            <div class="detail-main">
                              <div class="detail-main-line" v-show="!accountManager">
                                <div class="title">
                                  <div class="name">{{ $t('accountManagement') }}</div>
                                </div>
                                <div class="value">{{ $t('managementUserAccount') }}</div>
                                <el-button class="pc-button-right" type="text" @click="accountManager=true;">{{$t('edit')}}</el-button>
                              </div>
                              <div class="detail-main-line account-edit-main" v-show="accountManager">
                                <div style="width: 58%;float: left;">
                                  <div class="title" style="padding: 12px 0 0 15px !important;">
                                    <div class="name">{{ $t('accountManagement') }}</div>
                                  </div>
                                  <div class="value">{{ $t('deleteYouAccount') }}</div>
                                </div>
                                <div style="width: 40%;float: right" class="button">
                                  <el-button class="el-button--text" style="width: 76px;height: 42px" @click="cancelAccountPop()">{{ $t('LogoutAccount') }}</el-button>
                                  <el-button class="el-button--text" style="width: 76px;height: 42px" @click="accountManager=false;">{{ $t('back') }}</el-button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                      </el-skeleton>
                      <div class="clearBoth account-roominfo-clear"></div>
                      <div class="clearBoth account-roominfo-clear-50"></div>
                  </div>
              </div>
          </div>
          <div class="mobile-account-show" v-else>
            <el-skeleton animated :loading="userLoading">
              <template slot="template">
                <div class="account-detail" id="userInfo">
                  <div class="account-detail-top">
                      <div style="margin: 0 7%;"><el-skeleton-item variant="text" /></div>
                  </div>
                  <div class="detail-main">
                    <div class="detail-main-line" @click="nameSetup = true;emailSetup = false">
                      <div class="title"><el-skeleton-item variant="text" style="width:100px;"/></div>
                      <div class="clearBoth account-roominfo-clear-5"></div>
                      <div class="value"><el-skeleton-item variant="text" style="width:150px;"/></div>
                    </div>
                    <div class="detail-main-line">
                      <div class="title"><el-skeleton-item variant="text" style="width:100px;"/></div>
                      <div class="clearBoth account-roominfo-clear-5"></div>
                      <div class="value"><el-skeleton-item variant="text" style="width:150px;"/></div>
                    </div>
                    <div class="detail-main-line">
                      <div class="title"><el-skeleton-item variant="text" style="width:100px;"/></div>
                      <div class="clearBoth account-roominfo-clear-5"></div>
                      <div class="value"><el-skeleton-item variant="text" style="width:150px;"/></div>
                    </div>
                    <div class="detail-main-line">
                      <div class="title"><el-skeleton-item variant="text" style="width:100px;"/></div>
                      <div class="clearBoth account-roominfo-clear-5"></div>
                      <div class="value"><el-skeleton-item variant="text" style="width:150px;"/></div>
                    </div>
                  </div>
                </div>
              </template>
              <template>
                <el-card :body-style="{ padding: '0px' }">
                  <div class="account-detail" id="userInfo">
                    <div class="account-detail-top">
                        <div class="mobile-title">{{ $t('userDetails') }}（{{ $t('userId') }}：{{ userId }}）</div>
                    </div>
                    <div class="detail-main">
                      <div class="detail-main-line" @click="nameSetup = true;emailSetup = false">
                        <div class="title">{{ $t('name') }}：</div>
                        <div class="clearBoth account-roominfo-clear-5"></div>
                        <div class="value">{{ lastname }} {{ firstname }}</div>
                      </div>
                      <div class="detail-main-line" @click="emailClickAction()">
                        <div class="title">
                          {{ $t('email') }}：
                          <div v-if="email === ''" class="icon_blue_solid">{{ $t('iconNotBound') }}</div>
                          <div v-if="email !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
                          <div v-if="email !=='' && isVerify !== '1'" class="icon_red_hollow">{{ $t('iconNotVerified') }}</div>
                          <div v-if="email !== '' && isVerify === '1'" class="icon_green_hollow">{{ $t('iconVerified') }}</div>
                        </div>
                        <div class="clearBoth account-roominfo-clear-5"></div>
                        <div class="value">{{ email }}</div>
                      </div>
                      <div class="detail-main-line" @click="mobileClickAction()">
                        <div class="title">
                          {{ $t('mobile') }}：
                          <div v-if="mobile === ''" class="icon_blue_solid">{{ $t('iconNotBound') }}</div>
                          <div v-if="mobile !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
                        </div>
                        <div class="clearBoth account-roominfo-clear-5"></div>
                        <div class="value">{{ mobile }}</div>
                      </div>
                      <div class="detail-main-line" @click="wechatClickAction()">
                        <div class="title">
                          {{ $t('wechat') }}：
                          <div v-if="wechatAccount === ''" class="icon_blue_solid">{{ $t('iconNotBound') }}</div>
                          <div v-if="wechatAccount !== ''" class="icon_green_solid">{{ $t('iconBound') }}</div>
                        </div>
                        <div class="clearBoth account-roominfo-clear-5"></div>
                        <div class="value">{{ wechatAccount }}</div>
                      </div>
                      <el-dialog :visible.sync="unbindWechat" width="88%" top="35vh" class="del-dia" height="30vh">
                        <div slot="title" class="unbindWechatTitle">
                          {{ $t('unbindWechatTitle') }}
                        </div>
                        <div class="unbindWechatDesc">
                          {{ $t('unBindWechatConfirmMessage') }}
                        </div>
                        <div @click="UnBindWechat(true)" class="unbindWechatBtn">
                          {{ $t('determine') }}
                        </div>
                      </el-dialog>
                      <!--帐号管理-->
                      <div class="detail-main-line" v-show="!accountManager">
                        <div style="width: 68%;float: left;">
                          <div class="title">
                            <div class="name">{{ $t('accountManagement') }}</div>
                          </div>
                          <div class="value">{{ $t('managementUserAccount') }}</div>
                        </div>
                        <div style="width: 30%;height:72px;float: right;display: flex;justify-content: right;">
                          <el-button style="width: 76px;text-align: center;" type="text" @click="accountManager=true;">{{$t('edit')}}</el-button>
                        </div>
                      </div>
                      <div class="detail-main-line account-edit-main" v-show="accountManager">
                        <div style="width: 68%;height: 72px;float: left">
                          <div class="title" style="padding: 12px 0 0 15px !important;">
                            <div class="name">{{ $t('accountManagement') }}</div>
                          </div>
                          <div class="value">{{ $t('deleteYouAccount') }}</div>
                        </div>
                        <div style="width: 30%;height: 72px;float: right;display: flex;justify-content: right;">
                          <el-button style="width: 76px;text-align: center;display: flex;align-items: center;" type="text" @click="cancelAccountPop()">{{ $t('LogoutAccount') }}</el-button>
                          <el-button style="width: 76px;text-align: center;display: flex;align-items: center;" type="text" @click="accountManager=false;">{{ $t('back') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-card>
              </template>
            </el-skeleton>
            <div class="clearBoth account-roominfo-clear"></div>
            <div class="clearBoth account-roominfo-clear-50"></div>
          </div>
      </div>
  </el-main>
  <div style="clear:both"></div>
  <!-- menu -->
  <AccountModify v-if="common.isMobile()" :emailSetup="emailSetup" :conver="conver" :nameSetup="nameSetup" :mobileSetup="mobileSetup" :mobile="mobile" :lastname="lastname" :firstname="firstname" :email="email" :emailVerify="isVerify" @closepop="closePopSetup"></AccountModify>
  <CancelAccount :openCancel="cancelAccountShow" :source="source" :conver="conver" :language="language" @dialog-closed="cancelAccountClosed"></CancelAccount>
  <div class="clearBoth"></div>
  <publicFooter></publicFooter>
</el-container>
</template>

<script>
import { getUserInfo, modifyUserInfo, getPaymentList, delPayment, sendVerifyEmail, UnBindWechat, weiXinBind, unbindEmail, bindEmail, checkEmail, sendMobileCode, bindMobile } from '@/request/user.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicAccountMenu from '@/components/public/publicAccountMenu'
import wxlogin from '@/components/wechat/vue-wxlogin'
import AccountModify from '@/components/account/AccountModify'
import CancelAccount from '@/components/account/module/CancelAccount'
export default {
  name: 'myAccount',
  components: {
    publicFooter,
    publicHeader,
    publicAccountMenu,
    wxlogin,
    AccountModify,
    unbindEmail,
    bindEmail,
    checkEmail,
    sendMobileCode,
    bindMobile,
    CancelAccount
  },
  data () {
    return {
      userId: '',
      orderno: '',
      lastname: '',
      lastnameInput: '',
      lastnameError: false,
      firstname: '',
      firstnameInput: '',
      firstnameError: false,
      mobile: '',
      mobileBind: false,
      telOptions: [],
      telOptionsEn: [{id: 42, value: 'China +86', telnum: '+86'}, {id: 216, value: 'United States +1', telnum: '+1'}, {id: 36, value: 'Canada +1', telnum: '+1'}],
      telOptionsCn: [{id: 42, value: '中国 +86', telnum: '+86'}, {id: 216, value: '美国 +1', telnum: '+1'}, {id: 36, value: '加拿大 +1', telnum: '+1'}],
      oldSelectTel: 42,
      newSelectTel: 42,
      oldMobileError: '',
      oldMobileInput: '',
      mobileInput: '',
      codeInput: '',
      newMobileError: '',
      mobileCodeError: '',
      expireTime: 0,
      codeTimeExpire: false,
      email: '',
      emailBind: false,
      emailInput: '',
      emailError: false,
      emailErrorMsg: 'emailError',
      lastEmailSubDomainBlocklist: '',
      passwordInput: '',
      passWordError: false,
      retypePasswordInput: '',
      passWordTwoError: false,
      wechatAccount: '',
      wechatBindTime: '',
      oldlastname: '',
      oldfirstname: '',
      isVerify: '0',
      isVerifing: false,
      editImg: 'https://res.roompai.com/static/img/account/myaccount-edit.png',
      nameInput: false,
      paymentList: [],
      elementHeight: 0,
      ismobile: false,
      delShowClose: false,
      delDia: false,
      delid: '',
      currencyShow: false,
      unbindWechat: false,
      nameSetup: false,
      emailSetup: false,
      mobileSetup: false,
      remindNotice: '',
      remindNoticeShow: false,
      remindSuccess: '',
      remindSuccessShow: false,
      remindFail: '',
      remindFailShow: false,
      language: this.common.languageSet(this),
      accountChange: false,
      source: 'roompai',
      userLoading: true,
      paymentLoading: true,
      accountManager: false,
      cancelAccountShow: false,
      conver: ''
    }
  },
  created () {
    this.beforeMount()
  },
  mounted () {
    this.telOptions = this.language === 'en' ? this.telOptionsEn : this.telOptionsCn
    var conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    // 扫码成功跳转页面处理code参数.
    let code = this.common.linkQuerys.code
    if (code !== undefined) {
      let state = this.common.linkQuerys.appid
      let token = localStorage.getItem('token')
      let dataJson = {'operation': 'bindWechat', 'code': code, 'state': state, 'time': parseInt(new Date().getTime() / 1000), 'token': token}
      let data = this.common.encryptionData(dataJson, this)
      weiXinBind(data).then(res => {
        if (res.flag === '200') {
          this.wechatAccount = res.data.wechatAccount
          this.wechatBindTime = res.data.wechatBindTime
          if (this.common.isMobile() === true) {
            this.$message({
              type: 'success',
              customClass: 'mobile-el-message',
              message: this.$t('bindWechatSuccess')
            })
          } else {
            this.remindSuccess = 'bindWechatSuccess'
            this.remindSuccessShow = true
            setTimeout(() => { this.remindHide() }, 3000)
          }
          // 触发顶部显示新的个人信息.
          this.accountChange = !this.accountChange
        } else {
          if (this.common.isMobile() === true) {
            this.$message({
              type: 'error',
              customClass: 'mobile-el-message',
              message: this.$t(res.msg)
            })
          } else {
            this.remindFail = res.msg
            this.remindFailShow = true
            setTimeout(() => { this.remindHide() }, 3000)
          }
        }
      })
    }
    // 判断来源
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    }
    var path = this.common.routePath(this.$route.path)
    if (path.indexOf('user') !== -1) {
      document.querySelector('#userInfo').scrollIntoView({
        behavior: 'smooth'
      })
    } else if (path.indexOf('pay') !== -1) {
      document.querySelector('#payInfo').scrollIntoView({
        behavior: 'smooth'
      })
    } else {
      let newQuerys = this.common.linkEncode({'type': 'user', 'source': this.source, 'bindMobile': this.common.linkQuerys.bindMobile}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'type': 'user', 'source': this.source, 'bindMobile': this.common.linkQuerys.bindMobile, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'myAccount', params: {'querys': newQuerys}})
    }
    // 是否显示绑定手机号
    var bindMobile = this.common.linkQuerys.bindMobile
    if (bindMobile === '1') {
      this.mobileBind = true
    }
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
    } else {
      this.ismobile = false
    }
    var token = localStorage.getItem('token')
    if (token === undefined || token === null || token === 'null') {
      let locationHref = window.document.location.href
      sessionStorage.setItem('LoginWebsiteAddress', locationHref)
      let newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQuerys}})
    }
    this.common.stopScroll()
    this.getUserInfo()
    this.paymentLoading = true
    this.getPayment()
    this.paymentLoading = false
    this.common.canScroll()
  },
  watch: {
    language: function (newCur, oldCur) {
      this.telOptions = newCur === 'en' ? this.telOptionsEn : this.telOptionsCn
    }
  },
  methods: {
    hotelLanguage (language) {
      this.language = language
    },
    getMobileCode () {
      if (this.mobileInput === '') {
        this.newMobileError = 'pleaseValidPhone'
        return false
      }
      if (this.expireTime > 0) {
        return false
      }
      var that = this
      this.remindSuccess = false
      this.remindFail = false
      this.oldMobileError = ''
      this.newMobileError = ''
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let token = localStorage.getItem('token')
      let dataJson = {
        'token': token,
        'oldAreaCode': this.oldSelectTel,
        'oldMobile': this.oldMobileInput,
        'newAreaCode': this.newSelectTel,
        'newMobile': this.mobileInput,
        'time': time,
        'sessionid': sessionid,
        'operation': 'sendMobileCode'
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      sendMobileCode(data).then(res => {
        console.log(res)
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          that.expireTime = 60
          that.codeTimeExpire = setInterval(function () {
            console.log(that.expireTime)
            if (that.expireTime === 0) {
              clearInterval(that.codeTimeExpire)
            } else {
              that.expireTime = that.expireTime - 1
            }
          }, 1000)
          if (this.ismobile === false) {
            this.remindSuccess = 'sendCodeSuccess'
            this.remindSuccessShow = true
            setTimeout(() => { this.remindHide() }, 3000)
          } else {
            this.$message({
              type: 'success',
              customClass: 'mobile-el-message',
              message: this.$t('sendCodeSuccess')
            })
          }
          console.log('短信发送成功')
        } else if (res.flag === '201') {
          this.oldMobileError = res.msg
        } else {
          this.newMobileError = res.msg
        }
      })
    },
    bindMobile () {
      if (this.mobileInput === '') {
        this.newMobileError = 'pleaseValidPhone'
        return false
      }
      if (this.codeInput === '') {
        this.mobileCodeError = 'pleaseValidMobileCode'
        return false
      }
      this.newMobileError = ''
      this.mobileCodeError = ''
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var sessionid = this.common.sessionidGet(this)
      let token = localStorage.getItem('token')
      let dataJson = {
        'token': token,
        'newAreaCode': this.newSelectTel,
        'newMobile': this.mobileInput,
        'code': this.codeInput,
        'time': time,
        'sessionid': sessionid,
        'operation': 'BindMobile'
      }
      var data = this.common.encryptionData(dataJson, this)
      bindMobile(data).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.loadPageView(data, res, requestTime, responseTime)
        if (res.flag === '200') {
          this.mobile = this.mobileInput
          this.mobileBind = false
          if (this.ismobile === false) {
            this.remindSuccess = 'bindMobileSuccess'
            this.remindSuccessShow = true
            setTimeout(() => { this.remindHide() }, 3000)
          } else {
            this.$message({
              type: 'success',
              customClass: 'mobile-el-message',
              message: this.$t('bindMobileSuccess')
            })
          }
          // 1秒之后跳转回之前的页面.
          let websiteAddress = sessionStorage.getItem('BindMobileWebsiteAddress')
          if (websiteAddress !== null) {
            setTimeout(() => {
              window.document.location.href = websiteAddress
            }, 1000)
          }
        } else {
          this.mobileCodeError = res.msg
        }
      })
    },
    /**
     * 检验是否英文.
     */
    checkEnglish (refInfo) {
      let refName = this.$refs[refInfo].value
      // 姓名允许为空字符串, 默认为正常
      var checkRes = true
      if (refName) {
        var regExp = /^[A-Za-z]+$/
        checkRes = regExp.test(refName)
      }
      if (refInfo === 'firstName') {
        this.firstnameError = !checkRes
      } else if (refInfo === 'lastName') {
        this.lastnameError = !checkRes
      }
    },
    /**
     * pc端提示信息隐藏.
     */
    remindHide () {
      this.remindNoticeShow = false
      this.remindSuccessShow = false
      this.remindFailShow = false
    },
    /**
     * 移动端
     * 点击邮箱模块触发行为
     * 有绑定微信时可点击，无绑定微信不可操作.
     */
    emailClickAction () {
      if (this.email === '') {
        this.emailSetup = true
        this.nameSetup = false
        this.mobileSetup = false
      }
    },
    /**
     * 移动端
     * 点击手机号模块触发行为
     * 有绑定手机号时可点击，无绑定不可操作.
     */
    mobileClickAction () {
      this.emailSetup = false
      this.nameSetup = false
      this.mobileSetup = true
    },
    /**
     * 移动端
     * 点击微信模块触发行为.
     *
     * 1. 已绑定弹解绑弹窗
     * 2. 未绑定微信 且 微信环境打开 则跳转微信绑定
     * 3. 未绑定微信，非微信环境打开，不做任何操作
     */
    wechatClickAction () {
      if (this.wechatAccount !== '') {
        if (this.email !== '') {
          this.unbindWechat = true
        }
      } else if (this.common.isWechat() === true) {
        window.location.href = this.common.getWechatMobileAuthorizationUrl()
      }
    },
    /**
     * 解除微信绑定 - pc及移动端.
     */
    UnBindWechat (mobile = false) {
      // 处理参数.
      let token = localStorage.getItem('token')
      let dataJson = {'time': parseInt(new Date().getTime() / 1000), 'token': token, 'operation': 'unBindWechat'}
      let data = this.common.encryptionData(dataJson, this)
      // 移动端微信解绑.
      if (mobile === true) {
        UnBindWechat(data).then(res => {
          if (res.flag === '200') {
            this.unbindWechat = false
            this.wechatAccount = ''
            this.wechatBindTime = ''
            this.$message({
              type: 'success',
              customClass: 'mobile-el-message',
              message: this.$t('unBindWechatSuccess')
            })
          } else {
            this.$message({
              type: 'error',
              customClass: 'mobile-el-message',
              message: this.$t(res.msg)
            })
          }
        })
        return true
      }
      // pc端微信解绑.
      this.$confirm(this.$t('unBindWechatConfirmMessage'), this.$t('confirmTitle'), {
        type: 'warning'
      }).then(() => {
        this.remindHide()
        UnBindWechat(data).then(res => {
          if (res.flag === '200') {
            this.wechatAccount = ''
            this.remindSuccess = 'unBindWechatSuccess'
            this.remindSuccessShow = true
            // 触发顶部显示新的个人信息.
            this.accountChange = !this.accountChange
          } else {
            this.remindFail = res.msg
            this.remindFailShow = true
          }
          setTimeout(() => { this.remindHide() }, 3000)
        })
      })
    },
    /**
     * pc修改用户信息.
     */
    editAccount () {
      if (this.firstnameError || this.lastnameError) {
        return false
      }
      // 提交修改的用户信息
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      this.remindHide()
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'token': token, 'time': time, 'lastname': this.lastnameInput, 'firstname': this.firstnameInput, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      modifyUserInfo(data).then(res => {
        if (res.flag === '200') {
          this.nameInput = false
          this.lastname = this.lastnameInput
          this.firstname = this.firstnameInput
          this.remindSuccess = 'modifySuccess'
          this.remindSuccessShow = true
          // 触发顶部显示新的个人信息.
          this.accountChange = !this.accountChange
        } else {
          this.remindFail = 'modifyFail'
          this.remindFailShow = true
        }
        setTimeout(() => { this.remindHide() }, 3000)
      })
    },
    /**
     * pc解绑邮箱.
     */
    unbindEmail () {
      this.$confirm(this.$t('unBindEmailConfirmMessage'), this.$t('confirmTitle'), {
        type: 'warning'
      }).then(() => {
        this.remindHide()
        let token = localStorage.getItem('token')
        let dataJson = {'time': parseInt(new Date().getTime() / 1000), 'token': token, 'operation': 'unbindEmail'}
        let data = this.common.encryptionData(dataJson, this)
        unbindEmail(data).then(res => {
          if (res.flag === '200') {
            this.email = ''
            this.remindSuccess = 'unbindEmailSuccessNotice'
            this.remindSuccessShow = true
          } else {
            // 提示错误
            this.remindFail = res.msg
            this.remindFailShow = true
          }
          setTimeout(() => { this.remindHide() }, 3000)
        })
      })
    },
    checkEmailValue () {
      let emailSubDomain = this.emailInput.split('@')[1] || null
      const pattern = /^([a-zA-Z]|[0-9])(\.|\w|-)+@([a-zA-Z0-9])(\.|\w|-)+.([a-zA-Z]{2,})$/
      if (this.emailInput === '') {
        this.emailError = true
        this.emailErrorMsg = 'emailError'
      } else if (!pattern.test(this.emailInput)) {
        this.emailError = true
        this.emailErrorMsg = 'emailError'
      } else if (emailSubDomain === this.lastEmailSubDomainBlocklist) {
        this.emailError = true
        this.emailErrorMsg = 'emailSubDomainBlocklist'
      } else {
        this.emailError = false
      }
    },
    /**
     * pc绑定邮箱.
     */
    bindEmail () {
      this.checkEmailValue()
      this.passWordError = this.passwordInput.length < 6
      this.passWordTwoError = this.passwordInput !== this.retypePasswordInput
      if (this.emailError || this.passWordError || this.passWordTwoError) {
        return false
      }
      console.log(this.language)
      this.remindHide()
      let token = localStorage.getItem('token')
      let dataJson = {'operation': 'bindEmail', 'time': parseInt(new Date().getTime() / 1000), 'token': token, 'email': this.emailInput, 'password': this.passwordInput, 'passwordTwo': this.retypePasswordInput, 'source': this.source, 'language': this.language}
      let data = this.common.encryptionData(dataJson, this)
      bindEmail(data).then(res => {
        if (res.flag === '200') {
          this.email = this.emailInput
          this.isVerify = '0'
          this.emailBind = false
          // 绑定成功提醒
          this.remindNotice = 'mobileBindEmailSuccessNotice'
          this.remindNoticeShow = true
          // 定时检查邮箱是否验证通过.
          setTimeout(() => { this.checkEmailStatus() }, 5000)
        } else if (res.flag === '104') {
          this.lastEmailSubDomainBlocklist = this.emailInput.split('@')[1] || null
          this.emailError = true
          this.emailErrorMsg = 'emailSubDomainBlocklist'
        } else {
          // 绑定失败提醒
          this.remindFail = res.msg
          this.remindFailShow = true
        }
        setTimeout(() => { this.remindHide() }, 3000)
      })
    },
    // 验证邮箱.
    checkEmail () {
      this.remindHide()
      let token = localStorage.getItem('token')
      let dataJson = {'operation': 'checkEmail', 'time': parseInt(new Date().getTime() / 1000), 'token': token, 'source': this.source, 'language': this.language}
      let data = this.common.encryptionData(dataJson, this)
      checkEmail(data).then(res => {
        if (res.flag === '200') {
          this.remindNotice = 'mobileEmailCheckNotice'
          this.remindNoticeShow = true
        } else if (res.flag === '102') {
          this.isVerify = '1'
          this.email = res.email
          this.remindSuccess = 'mobileCheckEmailVerifySuccess'
          this.remindSuccessShow = true
        } else {
          // 绑定失败提醒
          this.remindFail = res.msg
          this.remindFailShow = true
        }
        setTimeout(() => { this.remindHide() }, 3000)
      })
    },
    /**
     * 检查邮箱验证状态.
     */
    checkEmailStatus () {
      let token = localStorage.getItem('token')
      let dataJson = {'operation': 'checkEmailStatus', 'time': parseInt(new Date().getTime() / 1000), 'token': token}
      let data = this.common.encryptionData(dataJson, this)
      checkEmail(data).then(res => {
        console.log(res)
        if (res.flag !== '200') {
          return false
        }
        if (res.data.is_verify === '1') {
          this.isVerify = '1'
          this.email = res.email
          this.remindSuccess = 'mobileCheckEmailVerifySuccess'
          this.remindSuccessShow = true
          setTimeout(() => { this.remindHide() }, 3000)
        } else if (res.data.email !== '') {
          setTimeout(() => { this.checkEmailStatus() }, 5000)
        }
      })
    },
    /**
     * pc显示绑定微信二维码.
     */
    pcBindWechatShowQRCode () {
      this.$alert(document.getElementById('wx').innerHTML, this.$t('bindWechat'), {
        dangerouslyUseHTMLString: true,
        center: true,
        showClose: false,
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonClass: 'wechatBindCancelButton'
      })
    },
    /**
     * 移动端-左侧浮层关闭触发.
     */
    closePopSetup: function (data) {
      this.nameSetup = false
      this.emailSetup = false
      this.mobileSetup = false
      if (data.type === 'nameSetup') {
        this.firstname = data.firstname
        this.lastname = data.lastname
      } else if (data.type === 'emailSetup') {
        this.email = data.email
        this.isVerify = data.emailVerify
      } else if (data.type === 'mobileSetup') {
        this.mobile = data.mobile
      }
      console.log(data)
    },
    beforeMount () {
      this.elementHeight = document.documentElement.clientHeight || document.body.clientHeight
    },
    cancelAccountPop () {
      console.log('cancelAccountPopClick')
      this.cancelAccountShow = true
    },
    cancelAccountClosed () {
      console.log('cancelAccountPopClose')
      this.cancelAccountShow = false
    },
    delPop: function (row, paymentData) {
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'id': row.id, 'token': token, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      delPayment(data).then(res => {
        if (res.flag === '200') {
          // this.getPayment()
          paymentData.splice(row, 1)
        }
      })
    },
    delDiaPayment (id) {
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'id': id, 'token': token, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      delPayment(data).then(res => {
        if (res.flag === '200') {
          this.getPayment()
          this.delDia = false
        }
      })
    },
    getSonSelect (val) {
      if (val === 'pay') {
        document.querySelector('#payInfo').scrollIntoView({
          behavior: 'smooth'
        })
      } else {
        document.querySelector('#userInfo').scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    getUserInfo () {
      this.userLoading = true
      // 判断用户是否登录 获取用户信息
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'token': token, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      getUserInfo(data).then(res => {
        if (res.flag === '131') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          // this.$router.push({name: 'login', query: {'source': this.source}})
          var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
          if (this.conver === 1 || this.conver === '1') {
            newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
          }
          this.$router.push({name: 'login', params: {'querys': newQuerys}})
        } else if (res.flag === '122') {
          this.lastname = ''
          this.firstname = ''
          this.userLoading = false
        } else {
          this.userId = res.data.show_id
          this.lastname = res.data.lastname
          this.firstname = res.data.firstname
          this.email = res.data.email
          this.mobile = res.data.mobile
          this.isVerify = res.data.is_verify
          this.isVerifing = res.data.isVerifing
          this.oldlastname = res.data.lastname
          this.oldfirstname = res.data.firstname
          this.wechatAccount = res.data.wechatAccount
          this.wechatBindTime = res.data.wechatBindTime
          if (this.email !== '' && this.isVerify !== '1') {
            // 定时检查邮箱是否验证通过.
            setTimeout(() => { this.checkEmailStatus() }, 5000)
          }
          this.userLoading = false
        }
      })
    },
    getPayment () {
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'token': token, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      getPaymentList(data).then(res => {
        if (res.flag === '200') {
          this.paymentList = res.data.list
        }
      })
    },
    sendEmailForVerify () {
      var token = localStorage.getItem('token')
      if (token === undefined || token === null || token === 'null') {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        // this.$router.push({name: 'login', query: {'source': this.source}})
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'login', params: {'querys': newQuerys}})
      }
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {'token': token, 'time': time, 'sessionid': sessionid}
      var data = this.common.encryptionData(dataJson, this)
      sendVerifyEmail(data).then(res => {
        if (res.flag === '200') {
          this.isVerify = '3'
          this.isVerifing = true
        }
      })
    },
    goback: function () {
      var LoginWebsiteAddress = sessionStorage.getItem('LoginWebsiteAddress')
      if (LoginWebsiteAddress !== null && LoginWebsiteAddress.indexOf('login/login') === -1) {
        window.document.location.href = LoginWebsiteAddress
      } else {
        var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
        if (this.conver === 1 || this.conver === '1') {
          newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
        }
        this.$router.push({name: 'Home', params: {'querys': newQuerys}})
      }
    }
  }
}
</script>

<style scoped>
.el-main{text-align: left;}
.main{background-color: #fff;width:100%;position:relative;min-height:800px;background:#FFFFFF;}

/* 右侧 */
.account-show{width: 100%; height: 100%;background:#FFFFFF;}
.account-show .account-center{width: 82%;height:100%; float:right;background: #FFFFFF;}
.account-center .account-data-info{width:70%;height:100%;margin:0 auto;}
.account-data-info .account-detail{width:100%;font-family: PingFangSCRegular, 'PingFang SC Semibold', 'PingFang SC', sans-serif;font-style: normal;font-size: 16px;}
.account-detail .account-detail-top{width:100%;height:50px;color: #FCD205;font-weight: 650;line-height:50px;}
.account-detail .account-detail-top .account-detail-data{float: right;height:100%;width:96%;}
.account-detail .account-detail-top .account-detail-data div{width:50px;height:50px;float:right;text-align:center;line-height:60px;}
.account-detail-data img{width:25px;height:25px;}
.account-detail .account-detail-main{width:94%;height:440px;background:white; margin: 0 auto;}
.account-detail .account-detail-main .account-detail-main-line{width: 100%;height: 33%;}
.account-detail .account-detail-main .account-detail-main-line .account-detail-main-line-center{width: 94%;height: 100%;margin:0 auto;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;color: #4F4C4C;font-size: 14px;}
.account-detail .account-detail-main .account-detail-main-line .account-detail-main-line-block{width:50%;height:100%;float:left;}
.account-detail .account-detail-main .account-detail-main-line .account-detail-main-line-block .el-input input{height:35px;}
.account-detail .account-detail-main .account-detail-main-line .account-detail-main-line-block .el-email-verfiy{overflow:hidden;height: 35px; background: #FFFBE6; line-height: 35px; border: solid 1px black;}

.detail-main {width: 94%;margin: 0 auto;background-color: rgba(79, 76, 76, 0.047);}
.detail-main-line {width: 100%;min-height: 72px;background: inherit;background-color: rgb(255, 255, 255);border: none;border-radius: 0;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;font-weight: 400;font-style: normal;font-size: 13px;color: rgb(79, 76, 76);box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 12px;margin-top: 10px;}
.detail-main-line:hover {cursor: pointer;}
.detail-main-line .title {height: 20px;line-height: 20px;padding: 12px 0 0 15px;font-size: 14px;font-weight: 500;}
.pc .title {width: 80%;float: left;}
.account-edit-main .title {padding: 10px 0 0 3px !important;}
.detail-main-line .title .name{display: inline-block;margin-right: 10px;}
.detail-main-line .value {height:20px;line-height: 20px;padding: 3px 0 0 15px;font-size: 13px;font-weight: 400;}
.pc .value {width: 80%;float: left;margin-top: 5px;}
.pc-button-right {width: 15%;height:72px;text-align: right;}
.account-edit-main .line{width: 45%;display: inline-block;margin: 2%;height: 70px}
.errorNotice {display: flex;font-weight: 400;font-size: 13px;color: rgb(225, 45, 45);height: 20px;margin-top: 8px;float: left;}
.account-edit-main .button{width:97%;text-align: right;height: 60px;margin-top: 15px;}
.buttonCancel {display: inline-block;width: 131px;height: 36px;padding: 10px 0;background: inherit;background-color: rgba(83, 146, 249, 0);border: none;border-radius: 6px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-size: 16px;color: #5392F9;}
.width80{width: 80%!important;}
.width85{width: 85%!important;}
.padding0{padding: 0 !important;}
.buttonSave{display: inline-block;width: 151px;height: 36px;padding: 10px 0;background: inherit;background-color: #5392F9;color:#FFFFFF;border: none;border-radius: 6px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-size: 16px;}
.buttonSave:hover {background-color:rgba(62, 108, 234, 1);}
.buttonCancel:hover {color:rgb(62,108,234);}
.detail-main-line .icon_green_solid {display: inline-block;padding: 0px 5px;height: 20px;background: inherit;background-color: rgba(115, 209, 61, 1);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-style: normal;font-size: 12px;color: #FFFFFF;text-align: center;line-height: 20px;}
.detail-main-line .icon_green_hollow {display: inline-block;padding: 0px 5px;height: 20px;background: inherit;background-color: rgba(246, 255, 237, 1);box-sizing: border-box;border-width: 1px;border-style: solid;border-color: rgba(183, 235, 143, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-style: normal;font-size: 12px;color: #52C41A;text-align: center;line-height: 20px;}
.detail-main-line .icon_blue_solid {display: inline-block;padding: 0px 5px;height: 20px;background: inherit;background-color: rgba(64, 169, 255, 1);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-style: normal;font-size: 12px;color: #FFFFFF;text-align: center;line-height: 20px;}
.detail-main-line .icon_red_hollow {display: inline-block;padding: 0px 5px;height: 20px;background: inherit;background-color: rgba(255, 242, 232, 1);box-sizing: border-box;border-width: 1px;border-style: solid;border-color: rgba(255, 187, 150, 1);border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;font-weight: 400;font-style: normal;font-size: 12px;color: #FA541C;text-align: center;line-height: 20px;}
.mobile-detail-pay-method {width: 94%;margin: 0 auto;border: none;border-radius: 0;box-shadow: rgba(0, 0, 0, 0.098) 0px 2px 12px;background-color: rgb(255, 255, 255);}
.mobile-detail-pay-method .title {padding: 5px 0 0 15px;height: 42px;line-height: 42px;font-size: 14px;font-weight: 500;color: rgb(79, 76, 76);}
.mobile-detail-pay-method-line {height: 54px;font-family: ArialMT, Arial, sans-serif;font-weight: 400;font-style: normal;font-size: 13px;letter-spacing: normal;color: rgb(51, 51, 51);text-align: center;line-height: normal;text-transform: none;background-color: rgb(255, 255, 255);box-sizing: border-box;border-width: 0px 0px 1px;border-bottom-style: solid;border-bottom-color: rgb(215, 215, 215);border-radius: 0px;box-shadow: none;}
.mobile-detail-pay-method-line .col1 {float: left;width: 9%;height: 54px;line-height: 54px;color: rgb(79, 76, 76);padding: 0px 0px 0px 20px;align-self: center;font-size: 14px;text-align: left;}
.mobile-detail-pay-method-line .col2 {float: left;width: 15%;height: 54px;line-height: 54px;}
.mobile-detail-pay-method-line .col2 img {width: 38px;height: 25px;vertical-align: middle;}
.mobile-detail-pay-method-line .col3 {float: left;width: 50%;height: 54px;line-height: 54px;font-size: 14px;text-align: left;color: rgb(79, 76, 76);padding: 0px 0px 0px 20px;}
.mobile-detail-pay-method-line .col4 {float: left;width: 14%;height: 54px;line-height: 54px;}
.mobile-detail-pay-method-line .col4 img {width: 20px;height: 20px;vertical-align: middle;}

/*换绑微信样式*/
.unbindWechatTitle {text-align: center;font-size: 16px;color: #303133; width: 100%;}
.unbindWechatDesc {font-size: 12px; color: #303133; text-align: center; line-height: 24px; width: 100%;overflow-wrap: break-word; word-wrap: break-word; -ms-word-break: break-all; word-break: break-all; word-break: break-word; -ms-hyphens: auto; -moz-hyphens: auto; -webkit-hyphens: auto; hyphens: auto;}
.unbindWechatBtn {border-top: 1px solid rgba(221, 223, 226, 1);font-weight: 100; font-style: normal; font-size: 16px; color: #5392F9; text-align: center; line-height: 50px; height: 50px;width: 100%;}

.account-detail-main-line-block .el-email-verfiy div{float:left; width: 35px; height: 35px; background: rgba(79, 76, 76, 1);text-align: center;display: flex; justify-content: center; align-items: center;margin-right: 10px;}
.account-detail-main-line-block .el-email-verfiy div img, .account-detail-main-line-block .el-email-verfiy-success div img{width:25px;height:25px;}
.el-email-verfiy-success{overflow:hidden;height: 35px; background: rgba(240, 249, 235, 1); line-height: 35px; border: solid 1px #67C23A; color:#67C23A;}
.el-email-verfiy-success div{float:left; width: 35px; height: 35px; background: #67C23A;text-align: center;display: flex; justify-content: center; align-items: center;margin-right: 10px;}
.verifyno{color:#5392F9; cursor: pointer;}
.verifying{color: #e0c125;}
.account-detail .account-detail-main .account-detail-main-center,.account-detail .account-detail-main-mobile .account-detail-main-center{width:95%;margin:0 auto;}
.account-detail .account-detail-main .account-detail-main-center .el-table__header-wrapper{height:20px;}

.data-block{box-shadow: 0 2px 12px #dcdfe2;}
.account-roominfo-clear{height:20px;width:100%;}
.account-roominfo-clear-65{height:65px;width:100%;}
.account-roominfo-clear-45{height:45px;width:100%;}
.account-roominfo-clear-50{height:50px;width:100%;}
.account-roominfo-clear-5{height:5px;width:100%;}

.float-left {float: left;}
.float-right {float: right;}
.account-detail-main-line-title a {color:rgb(83, 146, 249);}
.delpop .el-popconfirm .el-popconfirm__action .el-button--primary{background-color:rgba(79, 76, 76, 1);border-color:rgba(79, 76, 76, 1);}
.account-detail-main-center /deep/ .is-leaf{border:none !important;}
.account-detail-main-center /deep/ .el-table_1_column_4{text-align: right;}
.account-detail-main-center /deep/ .el-table_1_column_4 .cell{padding:0px;}
/* mobile */
.el-table ::-webkit-scrollbar { display: none;}
.mobile-payment{ border-bottom: 1px solid rgba(221, 223, 226, 1); height: 54px; line-height: 54px; width: 94%; margin: 0 auto;}
.mobile-payment div{display: inline-block;}
.account-detail-main .account-detail-main-payment{ min-height:50px;}
.mobile-main{min-height:600px; height:auto !important;background-color: rgba(79, 76, 76, 0.047);}
.mobile-title{ width: 94% !important; text-align: left !important; margin: 0 7%;color: #333333;}

/*动画效果*/
.my-message {transition: 1s;}
.v-enter {transform: translate(0%, -100%);}
.v-enter-to {transform: translate(0%, 0);}
.v-leave {transform: translate(0%, 0);}
.v-leave-to {transform: translate(0%, -100%);}

/*pc提示弹窗*/
.notice {min-height: 60px; text-align: center;font-size: 14px;font-weight: 400;width: -webkit-fill-available;position:absolute;top:1px;overflow: hidden;}
.remind-notice{border-width: 0px;min-height: 60px;background-color:rgba(228, 237, 253, 1);color:#5392F9;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.remind-notice-text{height: 60px;display:flex;align-items:center;justify-content:center;line-height: 20px;}
.remind-notice img {width: 18px;height: 18px;margin-right: 5px;margin-left:25px}
/* 成功提醒 */
.remind{ border-width: 0px;height: 60px;background: inherit;background-color: rgba(240, 249, 235);border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.remindinfo{padding-right: 18px;display: flex;justify-content: center;align-items: center;}
.img-success{ margin: 18px;width: 18px;height: 18px;background-color: rgba(103, 194, 58, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.remind-text{height: 60px;display:flex;align-items:center;justify-content:center;color: #67C23A;line-height: 20px;}
/* 失败提醒 */
.remind-faild{overflow: hidden;background: inherit;background-color: rgba(254, 240, 240, 1);border-width: 0px;height: 60px;border: none;border-radius: 4px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;}
.img-faild{margin: 18px;width: 18px;height: 18px;background-color: rgba(245, 108, 108, 1);border: none;border-radius: 15px;-moz-box-shadow: none;-webkit-box-shadow: none;box-shadow: none;text-align: center;line-height: normal;display:inline-block; margin-right:10px;}
.remind-text-faild{height: 60px;display:flex;align-items:center;justify-content:center;color: #F56C6C;line-height: 20px;}

.img-faild img, .img-success img {width:12px; height:12px;display: block;margin: 3px auto;}
/* 响应式 */
  @charset "UTF-8";

  @media only screen and (max-width:1099px){
      .main .menu-main{display:none}
      .main .account-show .account-center{width:100%;background-color: rgba(79, 76, 76, 0.047)}
      .main .account-show .account-center .account-data-info{width:95%;}
      .account-detail .account-detail-top{ color:rgb(51, 51, 51);}
      .account-detail .account-detail-top .account-detail-data{width:94%; margin: 0 3%;}
      .account-detail .account-detail-top .account-detail-data div{background-color: rgba(79, 76, 76, 0.047);}
      .account-detail .account-detail-main{ height:320px;}
      .account-detail .account-detail-main-mobile{ min-height:200px;}
      .account-detail .account-detail-main .account-detail-main-line{ height:101px;}
      .del-dia /deep/ .el-dialog__body{ padding:0;}
      .account-detail .account-detail-main .account-detail-main-center,.account-detail .account-detail-main-mobile .account-detail-main-center{width:94%;margin:0 auto;}
  }

  @media only screen and (min-width:1100px){
    .el-main{width:1100px;margin:60px auto;}
    .main{background-color: #fff;position:relative;width:100%;min-height:800px; margin: auto;}
    /* .menu-main{width: 255px;height: 100%;float: left;background-color: rgba(255, 255, 255, 1);border-right: none;-webkit-box-shadow: 0 2px 12px #ccc;box-shadow: 4px -2px 5px -3px #ccc;position: fixed;top: 60px;bottom: 300px;} */
    .menu-main {width: 255px;float: left;position: fixed;top: 60px;bottom: 360px;height: 100%}
    .main .account-show .account-center{width:100%;}
    .main .account-show .account-center .account-data-info{width:100%;}
    .main .account-show .account-center .account-data-info .account-order-pc{}
    .main .account-show .account-center .account-data-info .account-order-mobile{display:none;}
    .account-show{width: 825px; height: 100%;background:#FFFFFF;float: right;padding: 0 10px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/account/myAccount.vue